import { ReactComponent as SearchIcon } from '@Icons/additional/search.svg';

import '../header-actions.css';

const MobileSearch: React.FC = () => {
  return (
    <div className="header-action-component mobile-search trojan-neumorphism-box trojan-neumorphism-box-shadow">
      <SearchIcon />
    </div>
  );
};

export default MobileSearch;
